import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, PreloadAllModules, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
//import { LoginComponent } from 'src/app/login/login.component';
import { SessionService } from 'src/app/services/session.service';

/** AuthGuard para las rutas, que determina si el afiliado está logueado en la app antes de acceder a un recurso */

const AfiliadoRegistrado: CanActivateFn = (
  route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(SessionService).usuario? true : false;
  };
const AfiliadoSinRegistrat:CanActivateFn=(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(SessionService).inicioInstanciaSession? false : true;
};


const routes: Routes = [
  {
    path: "",
    loadChildren:()=> import('./content/content.module').then(m=> m.ContentModule)
  },
  /*{  --- solo para los que manejen un login propio
    path: "login",
    component: LoginComponent
  },*/
  {
    path:"**", redirectTo: ""
  },
  /*{
    path: "otra_ruta -- no restringida",
    component: componente no restringido
  }*/
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
